import { memo } from 'react';
import { NodeProps } from 'reactflow';
import { BaseNode } from './BaseNode';

export const ActionNode = memo((props: NodeProps) => {
  const getDescription = () => {
    const type = props.data.config?.actionType;
    if (!type) return 'Select an action';

    const labels: Record<string, string> = {
      text: '📝 Text',
      image: '🖼️ Image',
      video: '🎬 Video',
      audio: '🎵 Audio',
      document: '📄 File',
      openai: '🤖 OpenAI',
      groq: '⚡ Groq AI',
    };

    return labels[type] || type;
  };

  return (
    <BaseNode
      {...props}
      icon="🚀"
      label="Action"
      color="#3ddc97"
      description={getDescription()}
      onDelete={props.data.onDelete}
    />
  );
});

ActionNode.displayName = 'ActionNode';
